import { PhotoModel } from '../../types/protocols';

export interface BuildingCheckTemplate {
    id: string;
    name: string;
    description: string;
    estimatedTime: number; // in minutes
    takesMeasurement?: {
        metric: string; // kg, liter, mm, etc.
        acceptableRange?: {
            min?: number;
            max?: number;
        };
    };
    instructionalAttachments?: { [key: string]: PhotoModel }; // PhotoModel objects for attachments
    checklist?: string[]; // List of points to tick
    interval: {
        value: number;
        unit: 'days' | 'weeks' | 'months' | 'years';
    };
    nextDueDateCalculation: 'scheduled' | 'actual'; // relative to scheduled or actual due date
    photoRequired: boolean;
    estimatedCost: number;
    advanceNotice: number; // days before due date to notify
    createdAt: string;
    updatedAt: string;
}

export interface BuildingCheckTemplateFormData {
    name: string;
    description: string;
    estimatedTime: number;
    takesMeasurement: {
        enabled: boolean;
        metric: string;
        hasMinValue: boolean;
        hasMaxValue: boolean;
        minValue: number;
        maxValue: number;
    };
    instructionalAttachments: { [key: string]: PhotoModel };
    checklist: string[];
    interval: {
        value: number;
        unit: 'days' | 'weeks' | 'months' | 'years';
    };
    nextDueDateCalculation: 'scheduled' | 'actual';
    photoRequired: boolean;
    estimatedCost: number;
    advanceNotice: number;
}

export const INTERVAL_UNITS = [
    { value: 'days', label: 'Dagar' },
    { value: 'weeks', label: 'Veckor' },
    { value: 'months', label: 'Månader' },
    { value: 'years', label: 'År' }
] as const;

export const NEXT_DUE_DATE_OPTIONS = [
    { value: 'scheduled', label: 'Relativt till planerat datum' },
    { value: 'actual', label: 'Relativt till faktiskt genomfört datum' }
] as const;

// Condition Assessment Types
export interface ConditionAssessmentCategory {
    interval: {
        value: number;
        unit: 'days' | 'weeks' | 'months' | 'years';
    };
    instruction: string;
}

export interface ConditionAssessmentSettings {
    roofAndDrainage: ConditionAssessmentCategory;
    facadeAndWindows: ConditionAssessmentCategory;
    surfaces: ConditionAssessmentCategory;
}

export const CONDITION_ASSESSMENT_CATEGORIES = [
    { key: 'roofAndDrainage', label: 'Tak & avvattning' },
    { key: 'facadeAndWindows', label: 'Fasad & fönster' },
    { key: 'surfaces', label: 'Ytskikt invändigt' }
] as const;

// Default condition assessment settings
export const DEFAULT_CONDITION_ASSESSMENT_SETTINGS: ConditionAssessmentSettings = {
    roofAndDrainage: {
        interval: { value: 3, unit: 'years' },
        instruction: ''
    },
    facadeAndWindows: {
        interval: { value: 3, unit: 'years' },
        instruction: ''
    },
    surfaces: {
        interval: { value: 3, unit: 'years' },
        instruction: ''
    }
};

